import {
  allBorders,
  arrangeDataForSheet,
  cellFill,
  cellMaxWidth,
  leftRightBorders,
  setLocaleNumFmt,
  sheetFont,
} from "./";

export const hourlySheet = async (
  workbook,
  sheetName,
  data,
  gettext,
  locale,
) => {
  let monthColumns = data[0]?.monthColumns;
  let monthRows = data[0]?.monthRows;

  const worksheet = workbook.addWorksheet(sheetName);
  worksheet.columns = monthColumns.map((col) => ({
    header: col.headerName,
    key: col.field,
    type: col.type,
    width: col.width ? col.width / 10 : 10,
  }));

  const headerRow = worksheet.getRow(1);
  headerRow.font = sheetFont(true);
  headerRow.eachCell((cell) => {
    cell.border = allBorders();
  });
  
  const sumRowData = {
    ...monthRows[0],
    id: "sum",
    ts: "summary",
  };
  monthRows.unshift(sumRowData);

  monthRows.forEach((row) => {
    const rowData = arrangeDataForSheet(row, monthColumns, gettext);

    const addedRow = worksheet.addRow(rowData);
    const totalRows = monthRows.length;

    addedRow.eachCell((cell, colNumber) => {
      cell = setLocaleNumFmt(locale, cell);
      if (monthColumns[colNumber - 1].field === "ts") {
        cell.border = leftRightBorders("FFFFFFFF");
      } else {
        cell = cellFill(cell, "FFEBF1DE");
        cell.border = leftRightBorders("FFEBF1DE");
      }
      cell.font = sheetFont(false);

      //#region Month Sum
      if (monthColumns[colNumber - 1].field === "sum") {
        cell.font = sheetFont(true);
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "FFD8E4BC",
          }, // Background color for columns after "total"
        };
        const firstLetter = worksheet.getColumn(3).letter;
        const lastLetter = worksheet.getColumn(rowData.length).letter;
        cell.value = {
          formula: `SUM(${firstLetter}${cell.row}:${lastLetter}${cell.row})`,
        };
      }
      if (colNumber > 2 && parseInt(cell.row) === 2) {
        const letter = worksheet.getColumn(colNumber).letter;
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "FFD8E4BC",
          }, // Background color for columns after "total"
        };
        cell.value = {
          formula: `SUM(${letter}3:${letter}${totalRows + 1})`,
        };
      }
      if (cell.row === totalRows + 1) {
        cell.border = {
          left: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        };
      }
      //#endregion Month Sum
    });

    if (row.ts === "summary") {
      addedRow.font = sheetFont(true);
    }
  });

  worksheet.views = [
    {
      showGridLines: false,
      state: "frozen",
      xSplit: 2,
      ySplit: 2,
    },
  ];

  worksheet.columns.forEach((column, columnIndex) => {
    let maxWidth = 15;
    column.eachCell((cell) => {
      maxWidth = cellMaxWidth(cell.value, maxWidth);
    });
    worksheet.getColumn(columnIndex + 1).width = maxWidth;
  });
};
